export const Server = {
    BaseUrl: process.env.REACT_APP_SERVER_BASE_URL
}